import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import EntityMarquee from "@/components/landing/EntityMarquee";
import WhatWeDo from "@/components/landing/WhatWeDo";
import StatsBand from "@/components/landing/StatsBand";
import LogoMarquee from "@/components/landing/LogoMarquee";
import GovSection from "@/components/landing/GovSection";
import Entities from "@/components/landing/Entities";
import Manifesto from "@/components/landing/Manifesto";
import Footprint from "@/components/landing/Footprint";
import Engagement from "@/components/landing/Engagement";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-ink font-body text-white">
      <Header />
      <main>
        <Hero />
        <EntityMarquee />
        <WhatWeDo />
        <StatsBand />
        <LogoMarquee />
        <GovSection />
        <Entities />
        <Manifesto />
        <Footprint />
        <Engagement />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}

export default App;
